import {
    ReviewModalWidgetV2,
    useReviewContext,
} from '@reconvert/review-collector-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';
import { getUserReviewEligblity } from '../../services/review.service';
import { selectAppState } from '../../app/slice/appSlice';
import { redirect } from '../../utils/reviewModalRedireact';

function ReviewCollectorModalV2() {
    const { isVisible, showThanksForWidget } = useReviewContext();
    const { t } = useTranslation();
    const { platformStoreId } = useAppSelector(selectAppState);
    const [isEligible, setIsEligible] = useState(false);

    const WIDGET_NAME = 'MODAL_WIDGET_V2';

    useEffect(() => {
        const fetchUserReviewEligblity = async () => {
            try {
                const response = await getUserReviewEligblity(platformStoreId);

                setIsEligible(response.eligible);
            } catch (error) {
                console.error("error", error)
            }
        }

        fetchUserReviewEligblity();
    }, [platformStoreId]);

    return (
        <>
            {isEligible && (isVisible || showThanksForWidget === WIDGET_NAME) ? (
                <ReviewModalWidgetV2
                    title={t('How would you rate your experience so far?')}
                    widgetName={WIDGET_NAME}
                    page={"flow builder help"}
                    redirect={redirect}
                    closeButton={t('Not now')}
                />
            ) : null}
        </>
    );
}

export default ReviewCollectorModalV2;
